import { default as aboutYbzkRlH7u6Meta } from "E:/github/khalej/pages/about.vue?macro=true";
import { default as carmEF2zDQmWpMeta } from "E:/github/khalej/pages/car.vue?macro=true";
import { default as carsuRkrwEFs7PMeta } from "E:/github/khalej/pages/cars.vue?macro=true";
import { default as contactTUSvGVcJsyMeta } from "E:/github/khalej/pages/contact.vue?macro=true";
import { default as index95JcMd9SB7Meta } from "E:/github/khalej/pages/index.vue?macro=true";
import { default as jobscEPAlvvF2UMeta } from "E:/github/khalej/pages/jobs.vue?macro=true";
import { default as marketBhbiCz4MwlMeta } from "E:/github/khalej/pages/market.vue?macro=true";
import { default as indexNxqWJGzx4QMeta } from "E:/github/khalej/pages/news/index.vue?macro=true";
import { default as newCCfp22nNShMeta } from "E:/github/khalej/pages/news/new.vue?macro=true";
import { default as indexeijvlYx0yyMeta } from "E:/github/khalej/pages/offers/index.vue?macro=true";
import { default as offer4Oe2CvYZBkMeta } from "E:/github/khalej/pages/offers/offer.vue?macro=true";
import { default as order_45companyhe55xAGuSTMeta } from "E:/github/khalej/pages/order-company.vue?macro=true";
import { default as order_45individuals1XibGiEhmzMeta } from "E:/github/khalej/pages/order-individuals.vue?macro=true";
import { default as policyRejEhRAuh5Meta } from "E:/github/khalej/pages/policy.vue?macro=true";
import { default as servicesGsU3JYeQ5EMeta } from "E:/github/khalej/pages/services.vue?macro=true";
import { default as termscAAmcNJrx8Meta } from "E:/github/khalej/pages/terms.vue?macro=true";
import { default as wishlistA3foQhVr7IMeta } from "E:/github/khalej/pages/wishlist.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("E:/github/khalej/pages/about.vue")
  },
  {
    name: "about___ar___default",
    path: "/about",
    component: () => import("E:/github/khalej/pages/about.vue")
  },
  {
    name: "about___ar",
    path: "/ar/about",
    component: () => import("E:/github/khalej/pages/about.vue")
  },
  {
    name: "car___en",
    path: "/en/car",
    component: () => import("E:/github/khalej/pages/car.vue")
  },
  {
    name: "car___ar___default",
    path: "/car",
    component: () => import("E:/github/khalej/pages/car.vue")
  },
  {
    name: "car___ar",
    path: "/ar/car",
    component: () => import("E:/github/khalej/pages/car.vue")
  },
  {
    name: "cars___en",
    path: "/en/cars",
    component: () => import("E:/github/khalej/pages/cars.vue")
  },
  {
    name: "cars___ar___default",
    path: "/cars",
    component: () => import("E:/github/khalej/pages/cars.vue")
  },
  {
    name: "cars___ar",
    path: "/ar/cars",
    component: () => import("E:/github/khalej/pages/cars.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("E:/github/khalej/pages/contact.vue")
  },
  {
    name: "contact___ar___default",
    path: "/contact",
    component: () => import("E:/github/khalej/pages/contact.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    component: () => import("E:/github/khalej/pages/contact.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("E:/github/khalej/pages/index.vue")
  },
  {
    name: "index___ar___default",
    path: "/",
    component: () => import("E:/github/khalej/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("E:/github/khalej/pages/index.vue")
  },
  {
    name: "jobs___en",
    path: "/en/jobs",
    component: () => import("E:/github/khalej/pages/jobs.vue")
  },
  {
    name: "jobs___ar___default",
    path: "/jobs",
    component: () => import("E:/github/khalej/pages/jobs.vue")
  },
  {
    name: "jobs___ar",
    path: "/ar/jobs",
    component: () => import("E:/github/khalej/pages/jobs.vue")
  },
  {
    name: "market___en",
    path: "/en/market",
    component: () => import("E:/github/khalej/pages/market.vue")
  },
  {
    name: "market___ar___default",
    path: "/market",
    component: () => import("E:/github/khalej/pages/market.vue")
  },
  {
    name: "market___ar",
    path: "/ar/market",
    component: () => import("E:/github/khalej/pages/market.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("E:/github/khalej/pages/news/index.vue")
  },
  {
    name: "news___ar___default",
    path: "/news",
    component: () => import("E:/github/khalej/pages/news/index.vue")
  },
  {
    name: "news___ar",
    path: "/ar/news",
    component: () => import("E:/github/khalej/pages/news/index.vue")
  },
  {
    name: "news-new___en",
    path: "/en/news/new",
    component: () => import("E:/github/khalej/pages/news/new.vue")
  },
  {
    name: "news-new___ar___default",
    path: "/news/new",
    component: () => import("E:/github/khalej/pages/news/new.vue")
  },
  {
    name: "news-new___ar",
    path: "/ar/news/new",
    component: () => import("E:/github/khalej/pages/news/new.vue")
  },
  {
    name: "offers___en",
    path: "/en/offers",
    component: () => import("E:/github/khalej/pages/offers/index.vue")
  },
  {
    name: "offers___ar___default",
    path: "/offers",
    component: () => import("E:/github/khalej/pages/offers/index.vue")
  },
  {
    name: "offers___ar",
    path: "/ar/offers",
    component: () => import("E:/github/khalej/pages/offers/index.vue")
  },
  {
    name: "offers-offer___en",
    path: "/en/offers/offer",
    component: () => import("E:/github/khalej/pages/offers/offer.vue")
  },
  {
    name: "offers-offer___ar___default",
    path: "/offers/offer",
    component: () => import("E:/github/khalej/pages/offers/offer.vue")
  },
  {
    name: "offers-offer___ar",
    path: "/ar/offers/offer",
    component: () => import("E:/github/khalej/pages/offers/offer.vue")
  },
  {
    name: "order-company___en",
    path: "/en/order-company",
    component: () => import("E:/github/khalej/pages/order-company.vue")
  },
  {
    name: "order-company___ar___default",
    path: "/order-company",
    component: () => import("E:/github/khalej/pages/order-company.vue")
  },
  {
    name: "order-company___ar",
    path: "/ar/order-company",
    component: () => import("E:/github/khalej/pages/order-company.vue")
  },
  {
    name: "order-individuals___en",
    path: "/en/order-individuals",
    component: () => import("E:/github/khalej/pages/order-individuals.vue")
  },
  {
    name: "order-individuals___ar___default",
    path: "/order-individuals",
    component: () => import("E:/github/khalej/pages/order-individuals.vue")
  },
  {
    name: "order-individuals___ar",
    path: "/ar/order-individuals",
    component: () => import("E:/github/khalej/pages/order-individuals.vue")
  },
  {
    name: "policy___en",
    path: "/en/policy",
    component: () => import("E:/github/khalej/pages/policy.vue")
  },
  {
    name: "policy___ar___default",
    path: "/policy",
    component: () => import("E:/github/khalej/pages/policy.vue")
  },
  {
    name: "policy___ar",
    path: "/ar/policy",
    component: () => import("E:/github/khalej/pages/policy.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    component: () => import("E:/github/khalej/pages/services.vue")
  },
  {
    name: "services___ar___default",
    path: "/services",
    component: () => import("E:/github/khalej/pages/services.vue")
  },
  {
    name: "services___ar",
    path: "/ar/services",
    component: () => import("E:/github/khalej/pages/services.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("E:/github/khalej/pages/terms.vue")
  },
  {
    name: "terms___ar___default",
    path: "/terms",
    component: () => import("E:/github/khalej/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    component: () => import("E:/github/khalej/pages/terms.vue")
  },
  {
    name: "wishlist___en",
    path: "/en/wishlist",
    component: () => import("E:/github/khalej/pages/wishlist.vue")
  },
  {
    name: "wishlist___ar___default",
    path: "/wishlist",
    component: () => import("E:/github/khalej/pages/wishlist.vue")
  },
  {
    name: "wishlist___ar",
    path: "/ar/wishlist",
    component: () => import("E:/github/khalej/pages/wishlist.vue")
  }
]